import * as React from "react";
import "./style_5.scss";

export default function ProductAccordionContentStyle5({ infoBlock }) {
  return (
    <div className={`accordion-content-block style_5`}>
      <h3>{infoBlock.title}</h3>
      {infoBlock.url_path && (
        <h4>
          <a target={"_blank"} href={infoBlock.url_path}>
            {infoBlock.url_name}
          </a>
        </h4>
      )}
      {infoBlock.links && infoBlock.links.length > 0 && (
        <ul className={`link-list`}>
          {infoBlock.links.map((link) => (
            <li key={link.url_name}>
              <a target={`_blank`} href={link.url_path}>
                {link.url_name}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
